/// <amd-module name="Artifacts/Conda/CondaProtocol" />
/* eslint-disable @typescript-eslint/no-unused-vars */
import { logoContributionId } from "Artifacts/Conda/components/Logo";
import { CondaModule } from "Artifacts/Conda/redux/";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class CondaProtocol implements IProtocol {
  public readonly id = "Conda";
  public readonly name = "Conda";
  public readonly statusUrl = "https://conda-forge.org/status/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    return [];
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    throw new Error("not Implemented");
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    throw new Error("not Implemented");
  }

  public getReduxModule(): IModuleTuple {
    return CondaModule;
  }

  getUpstreamOverrideStatus(
    _pageContext: IVssPageContext,
    _packageName: string,
    _feed?: IFeed,
  ): Promise<boolean> {
    throw new Error("Conda does not support Upstream Override");
  }

  public getUpstreamingProperties(pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: false,
      isAadUpstreamsSupported: false,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return false;
  }
}

ProtocolService.registerProtocol(new CondaProtocol());
